var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"100%","height":"100%","viewBox":"0 0 80 80","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('rect',{attrs:{"width":"80","height":"80","rx":"10","fill":_vm.color}})])
}
var staticRenderFns = []

export { render, staticRenderFns }